export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_06.9bc851fd.png";